<template>
  <div class="woo-email-wrapper">
    <router-link to="/" class="woo-email-back">
      <v-icon style="color: black;"> mdi-arrow-left </v-icon>
    </router-link>
    <div class="woo-email">
      <v-img
        :src="require('@/assets/crochet.jpeg')"
        :lazy-src="require('@/assets/crochet.jpeg')"
        height="280"
        width="280"
        style="margin: auto;"
        aspect-ratio="1"
        class="woo-email-image"
      />
      <div style="margin: 20px 0px;">
        <h2 style="margin-bottom: 15px; line-height: 1;">One last thing...</h2>
        <p>Sign up to get free unlimited help over email</p>
      </div>
      <div class="woo-email-form klaviyo-form-WS2v4n" :id="theme"></div>
      <a class="woo-email-later" @click="later">
        Maybe later
      </a>
    </div>
  </div>
</template>
<script>
import HelperMethods from '@/helpers/HelperMethods';
export default {
  name: 'EmailCollectView',
  beforeMount() {
    // If we can't render the email collection form, we'll have to proceed
    if (!HelperMethods.isKlaviyoAvailable()) {
      this.navigate()
    }
  },
  mounted() {
    window.addEventListener('klaviyoForms', e => { 
      if (e.detail.type === 'submit') {
        this.navigate()
      }
    });

    window.scrollTo(0, 0);
  },
  methods: {
    later() {
      this.navigate()
    },
    navigate() {
      if (this.$route.query.d) {
        window.location = HelperMethods.decryptUrlSafe(this.$route.query.d);
      } else {
        this.$router.push(this.$route.query.r);
      }
    }
  },
  data() {
    return {
      theme: new Date().getTime(),
    };
  }
};
</script>
<style lang="scss">
.woo {
  &-email {
    max-width: 20rem;
    margin: auto;
    top: 88px;
    padding-bottom: 2rem;

    &-back {
      top: 40px;
      left: 30px;
      position: absolute;
    }

    &-wrapper {
      background: #59aea7;
      height: 100%;
    }

    &-later {
      color: #000 !important;
      text-decoration: underline !important;
      font-size: 0.875rem;
      font-weight: 700;
      text-align: center;
    }
    
    &-form {
      margin-bottom: 16px;

      input {
        padding-left: 20px !important;
        font-family: Karla !important;
        box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%) !important;
        width: 100%;
        // position: relative !important;

        &:focus {
          outline: none;
        }

        z-index: 0 !important;
      }

      button {
        color: black !important;
        cursor: pointer !important;
        font-size: 2rem !important;
        position: absolute;
        height: 64px !important;
        width: 64px !important;
        top: -4px;
        right: -4px;
        z-index: 10 !important;

        &:focus {
          outline: none !important;
          box-shadow: none !important;
        }

        &:active {
          outline: none !important;
          box-shadow: none !important;
        }

        &:before {
          content: "\F0054";
          cursor: pointer !important;
          display: inline-block;
          font: normal normal normal 24px/1 "Material Design Icons";
          font-size: inherit;
          text-rendering: auto;
          padding: 1rem 0;
          position: absolute;
          right: 25px;
          top: 0px;
          line-height: inherit;
          -webkit-font-smoothing: antialiased;
        }
      }
    }
  }
}
</style>
